import { jsxs, jsx } from "react/jsx-runtime";
import { useClassNameFactory, useColorScheme } from "@contember/react-utils";
import { deprecate, isDefined, fallback, themeClassName, colorSchemeClassName, dataAttribute } from "@contember/utilities";
import { memo } from "react";
import { Text } from "../Typography/Text.js";
const Message = memo(({
  action,
  background,
  borderRadius = true,
  children,
  className,
  display = "block",
  distinction,
  elevated = false,
  flow,
  icon,
  important,
  intent = "positive",
  lifted,
  padding,
  size,
  textAlign,
  ...props
}) => {
  deprecate("1.3.0", isDefined(lifted), "`lifted` prop", "`elevated` prop");
  elevated = fallback(elevated, isDefined(lifted), lifted ?? false);
  deprecate("1.3.0", isDefined(flow), "`flow` prop", "`display` prop");
  display = fallback(display, flow === "block" || flow === "generousBlock", "block");
  padding = fallback(padding, flow === "generous" || flow === "generousBlock", "large");
  deprecate("1.3.0", isDefined(distinction), "`distinction` prop", "combination of `important` and/or `padding` props");
  important = fallback(important, distinction === "striking", true);
  padding = fallback(padding, distinction === "striking", true);
  deprecate("1.3.0", size === "default", '`size="default"` prop', "omit `size` prop");
  size = fallback(size, size === "default", void 0);
  const componentClassName = useClassNameFactory("message");
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...props,
      className: componentClassName(null, [
        ...themeClassName(intent),
        colorSchemeClassName(useColorScheme()),
        className
      ]),
      "data-background": dataAttribute(background ?? (elevated || important ? true : void 0)),
      "data-border-radius": dataAttribute(borderRadius),
      "data-display": dataAttribute(display),
      "data-elevated": dataAttribute(elevated),
      "data-important": dataAttribute(important),
      "data-padding": dataAttribute(padding ?? (important || elevated ? true : void 0)),
      "data-size": dataAttribute(size),
      "data-text-align": dataAttribute(textAlign),
      children: [
        icon && /* @__PURE__ */ jsx("div", { className: componentClassName("icon"), children: icon }),
        /* @__PURE__ */ jsx("div", { className: componentClassName("content"), children: typeof children === "string" || typeof children === "number" ? /* @__PURE__ */ jsx(Text, { children }) : children }),
        action && /* @__PURE__ */ jsx("div", { className: componentClassName("action"), children: action })
      ]
    }
  );
});
Message.displayName = "Message";
export {
  Message
};
//# sourceMappingURL=Message.js.map
